import { genUiI18n } from './i18n.js';
import type { FlightFilterCopy } from '@voll-intelligence/intelligence-ui-kit';

/** Os textos do `FlightFilterPanel` do kit no locale do host. Função pura, sem
 *  Context, como o `flightPlannerCopy`: o host memoiza por locale. */
export function flightFilterCopy(locale: string | null | undefined): FlightFilterCopy {
  const { t } = genUiI18n(locale);
  return {
    filters: t('flightFilter.filters'),
    reset: t('flightFilter.reset'),
    close: t('flightFilter.close'),
    cabin: {
      label: t('flightExplorer.cabin'),
      refetch: t('flightExplorer.cabinRefetch'),
      economy: t('flightExplorer.cabin.economy'),
      premium: t('flightExplorer.cabin.premium'),
      business: t('flightExplorer.cabin.business'),
      first: t('flightExplorer.cabin.first'),
      outOfPolicy: t('flightExplorer.cabinOutOfPolicy'),
      allowedFromHours: (hours) => t('flightExplorer.cabinAllowedFromHours', { hours }),
      outBelowHours: (hours) => t('flightExplorer.cabinOutBelowHours', { hours }),
    },
    policy: { label: t('flightFilter.policy'), withinPolicy: t('flightFilter.withinPolicy') },
    stops: {
      label: t('flightFilter.stops.label'),
      direct: t('flightFilter.stops.direct'),
      one: t('flightFilter.stops.one'),
      two: t('flightFilter.stops.two'),
      above: t('flightFilter.stops.above'),
    },
    time: {
      label: t('flightFilter.time'),
      departs: t('flightFilter.departs'),
      arrives: t('flightFilter.arrives'),
      departureTime: t('flightFilter.departureTime'),
      arrivalTime: t('flightFilter.arrivalTime'),
    },
    price: {
      label: t('flightFilter.price'),
      min: t('flightFilter.minPrice'),
      max: t('flightFilter.maxPrice'),
    },
    airline: t('flightFilter.airline'),
    airports: { label: t('flightFilter.airports'), otherCities: t('flightFilter.otherCities') },
    flightNumber: {
      label: t('flightFilter.flightNumber'),
      placeholder: t('flightFilter.flightNumberPlaceholder'),
    },
  };
}
